import React from 'react';
import axios from 'axios';
import { Instagram } from 'lucide-react';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/competitor-analysis`;
const cfg = { withCredentials: true };

export const caApi = {
  get: (p = '', params) => axios.get(`${BASE}${p}`, { ...cfg, params }).then((r) => r.data),
  post: (p, b = {}) => axios.post(`${BASE}${p}`, b, cfg).then((r) => r.data),
  put: (p, b) => axios.put(`${BASE}${p}`, b, cfg).then((r) => r.data),
  del: (p) => axios.delete(`${BASE}${p}`, cfg).then((r) => r.data),
};

export const BLUE = '#3B4FD8';
export const TYPE_COLORS = { reel: '#3B4FD8', static: '#22B8CF', carousel: '#F59F00' };
export const errMsg = (e, f) => (typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : f);
export const num = (n) => (n == null ? '—' : n >= 1e6 ? `${(n / 1e6).toFixed(1)}M` : n >= 1e3 ? `${(n / 1e3).toFixed(1)}K` : String(Math.round(n)));
export const dateText = (iso) => (iso ? new Date(iso.endsWith('Z') || iso.includes('+') ? iso : `${iso}Z`).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');

export const BTN_PRIMARY = 'inline-flex items-center gap-1.5 rounded-lg px-4 py-2 text-sm font-semibold text-white bg-[#3B4FD8] hover:bg-[#2F40B8] disabled:opacity-50 transition-colors';
export const BTN_OUTLINE = 'inline-flex items-center gap-1.5 rounded-lg px-4 py-2 text-sm font-semibold text-[#3B4FD8] border border-[#3B4FD8]/40 bg-white dark:bg-transparent hover:bg-[#3B4FD8]/5 disabled:opacity-50 transition-colors';
export const CARD = 'bg-white dark:bg-[#0F1115] border border-[#E6E8F0] dark:border-white/5 rounded-xl shadow-[0_1px_3px_rgba(16,24,40,0.06)]';
export const TH = 'px-4 py-3 text-left text-xs font-semibold text-white bg-[#3B4FD8] whitespace-nowrap';
export const TD = 'px-4 py-3 text-sm text-[#1F2937] dark:text-zinc-200 border-t border-[#EEF0F6] dark:border-white/5';

export const Avatar = ({ name, size = 40 }) => (
  <div className="rounded-full bg-[#3B4FD8]/10 text-[#3B4FD8] font-bold flex items-center justify-center shrink-0" style={{ width: size, height: size, fontSize: size * 0.4 }}>{(name || '?').replace(/^@/, '')[0]?.toUpperCase()}</div>
);

export const Handle = ({ h, className = '' }) => (
  <a href={`https://www.instagram.com/${h}/`} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-1 text-sm text-[#6B7280] hover:text-[#3B4FD8] transition-colors ${className}`}><Instagram size={13} className="text-[#E1306C]" />@{h}</a>
);

const TIER_CLS = { Nano: 'bg-sky-50 text-sky-700', Micro: 'bg-emerald-50 text-emerald-700', Macro: 'bg-violet-50 text-violet-700', Mega: 'bg-amber-50 text-amber-700', Unknown: 'bg-gray-100 text-gray-500' };
export const TierBadge = ({ tier, testid }) => <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${TIER_CLS[tier || 'Unknown']}`} data-testid={testid}>{tier || 'Unknown'}</span>;

export const TypeBadge = ({ type }) => (
  <span className="rounded-md px-2 py-0.5 text-[11px] font-semibold text-white capitalize" style={{ background: TYPE_COLORS[type] }}>{type}</span>
);
